import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { localeData } from '../../../locales/data';
import { addModifiers, getLanguageCode } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface AlphasTagsPaginationProps {
  pageSize?: number;
  itemsCount?: number;
  changePrevPage: () => void;
  changeNextPage: () => void;
  getPaginationNumbers: () => any[];
  page: number;
  changePage: (val: number) => void;
  pages: number;
  changePageSize?: (e: any) => void;
  pageSizeLimit?: number;
  allowPageSizeChange?: boolean;
  additionalMessage?: string;
  isSearchLimitWarningShown?: boolean;
}

export const AlphasTagsPagination =
  (ComponentNum: any) =>
  ({
    pageSize,
    itemsCount,
    changePrevPage,
    changeNextPage,
    getPaginationNumbers,
    page,
    changePage,
    pages,
    changePageSize,
    pageSizeLimit,
    allowPageSizeChange,
    additionalMessage,
    isSearchLimitWarningShown,
  }: AlphasTagsPaginationProps): JSX.Element =>
    (
      <div className="pagination-footer">
        {ComponentNum && (
          <ComponentNum
            pageSize={pageSize}
            itemsCount={itemsCount}
            changePageSize={changePageSize}
            pageSizeLimit={pageSizeLimit}
            allowPageSizeChange={allowPageSizeChange}
            cssModifiers={['pagination-footer']}
            additionalMessage={additionalMessage}
          />
        )}
        {isSearchLimitWarningShown && (
          <div className="data-table__search-limit-warning">
            <FormattedMessage id="dataExplorer.searchLimitWarning" />
          </div>
        )}
        <div className="pagination-footer__buttons-container">
          <button
            onClick={changePrevPage}
            disabled={page === 0 || itemsCount === 0}
            data-testid={'pagination-prev-button'}
            className={addModifiers('pagination-footer__button', ['previous', page === 0 || itemsCount === 0 ? 'disabled' : 'active'])}
          >
            <FormattedMessageHelper tagName="span" id="tablePagination.4" defaultMessage={localeData.en['tablePagination.4']} />
          </button>
          {getPaginationNumbers().map((val: any, index: number) => {
            const pageNum = page + 1;
            let changePageVal = val;
            if (typeof val === 'number') {
              changePageVal = val - 1;
            }
            const changeNumberedPage = () => changePage(changePageVal);
            const isDots = val === '...';

            return val === pageNum ? (
              <button className={addModifiers('pagination-footer__button', ['active'])} key={index}>
                {val.toLocaleString(getLanguageCode())}
              </button>
            ) : (
              <button
                data-testid={`pagination-${index + 1}-button`}
                key={index}
                onClick={changeNumberedPage}
                className={addModifiers('pagination-footer__button', ['inactive', ...(isDots ? ['dots'] : [])])}
              >
                {val.toLocaleString(getLanguageCode())}
              </button>
            );
          })}
          <button
            data-testid={'pagination-next-button'}
            onClick={changeNextPage}
            disabled={page === pages - 1 || itemsCount === 0}
            className={addModifiers('pagination-footer__button', ['next', page === pages - 1 || itemsCount === 0 ? 'disabled' : 'active'])}
          >
            <FormattedMessageHelper tagName="span" id="tablePagination.5" defaultMessage={localeData.en['tablePagination.5']} />
          </button>
        </div>
      </div>
    );
